import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import determinarPaginaAtualTomadores from '../../actions/cteos/tomador/determinarPaginaAtualTomador'
import BotoesPaginacao from '../comum/BotoesPaginacao'

export class BotoesPaginacaoTomador extends Component {
  render () {
    return <BotoesPaginacao
      numeroElementos={this.props.total}
      paginaAtual={this.props.paginaAtual}
      registrosPorPagina={this.props.registrosPorPagina}
      determinarPaginaAtual={this.props.determinarPaginaAtualTomadores}/>
  }
}

export function mapStateToProps (state) {
  return {
    paginaAtual: state.tomador.paginaAtualTomadores,
    total: state.tomador.total,
    registrosPorPagina: state.tomador.registrosPorPaginaTomadores
  }
}

export function mapDispatchToProps (dispatch) {
  return bindActionCreators({ determinarPaginaAtualTomadores }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(BotoesPaginacaoTomador)
